// extracted by mini-css-extract-plugin
module.exports = {"componentStyle":"LotteryDetailKv_componentStyle__b7TZ7"};